import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { parseReactProps } from '~/components/legacy/reactProps.js';
import legacyEventHub from '~/modules/legacyRuntime.js';
import ProjectAddTo from '~/components/legacy/ProjectAddTo.jsx';

class TrackHeroActionBar extends Component {
  constructor(props) {
    super(props);

    this.handleUpdateTrackFavorites = this.handleUpdateTrackFavorites.bind(this);
    this.handleFavoriteClick = this.handleFavoriteClick.bind(this);
    this.handleDemoDownloadClick = this.handleDemoDownloadClick.bind(this);
    this.handleShareClick = this.handleShareClick.bind(this);
    this.handleLicenseClick = this.handleLicenseClick.bind(this);
    this.handleUpdateTrackInfo = this.handleUpdateTrackInfo.bind(this);
    this.handleUpdateTrackVariantInfo = this.handleUpdateTrackVariantInfo.bind(this);
    this.handleAudioPlayerPlay = this.handleAudioPlayerPlay.bind(this);
    this.handlePlayTrack = this.handlePlayTrack.bind(this);
    this.handlePlayTrackVariant = this.handlePlayTrackVariant.bind(this);

    this.state = {
      trackFavorites: Array.isArray(this.props.trackFavorites) ? this.props.trackFavorites : [],
      shareCopied: false,
      activeTrackVariant: this.initialTrackVariant()
    };
    this.eventHubListeners = [];
  }

  initialTrackVariant() {
    if (typeof window === 'undefined' || !window.location) {
      return null;
    }

    const searchParams = new URLSearchParams(window.location.search || '');
    const pendingTrackId = searchParams.get('catalog_project_action_track_id');
    const pendingVariantId = searchParams.get('catalog_project_action_track_variant_id');
    if (!pendingVariantId || !this.isOwnTrack(pendingTrackId)) {
      return null;
    }

    return this.variantForId(pendingVariantId);
  }

  variantForId(variantId) {
    return (Array.isArray(this.props.trackVariants) ? this.props.trackVariants : []).find((variant) => String(variant.id) === String(variantId)) || { id: variantId };
  }

  isOwnTrack(trackId) {
    return String(trackId) === String(this.props.trackId);
  }

  componentDidMount() {
    if (!legacyEventHub || typeof legacyEventHub.on !== 'function') {
      return;
    }

    this.registerEventHubListener('updateTrackFavorites', this.handleUpdateTrackFavorites);
    this.registerEventHubListener('updateTrackInfo', this.handleUpdateTrackInfo);
    this.registerEventHubListener('updateTrackVariantInfo', this.handleUpdateTrackVariantInfo);
    this.registerEventHubListener('audioPlayerPlay', this.handleAudioPlayerPlay);
    this.registerEventHubListener('playTrack', this.handlePlayTrack);
    this.registerEventHubListener('playTrackVariant', this.handlePlayTrackVariant);
  }

  componentWillUnmount() {
    if (!legacyEventHub || typeof legacyEventHub.off !== 'function') {
      return;
    }

    this.eventHubListeners.forEach(({ eventName, handler }) => legacyEventHub.off(eventName, handler));
    this.eventHubListeners = [];
  }

  registerEventHubListener(eventName, handler) {
    legacyEventHub.on(eventName, handler);
    this.eventHubListeners = this.eventHubListeners || [];
    this.eventHubListeners.push({ eventName, handler });
  }

  handleUpdateTrackFavorites(args) {
    const payload = Array.isArray(args) ? args[0] : args;
    this.setState({
      trackFavorites: Array.isArray(payload) ? payload : []
    });
  }

  handleUpdateTrackInfo(args) {
    const payload = Array.isArray(args) ? args[0] : args;
    if (payload && this.isOwnTrack(payload.id)) {
      this.setState({ activeTrackVariant: null });
    }
  }

  handleUpdateTrackVariantInfo(args) {
    const payload = Array.isArray(args) ? args : [args];
    const trackData = payload[0];
    const variantData = payload[1];
    if (trackData && this.isOwnTrack(trackData.id) && variantData) {
      this.setState({ activeTrackVariant: variantData });
    }
  }

  handleAudioPlayerPlay(args) {
    const eventArgs = Array.isArray(args) ? args : [args];
    const trackData = eventArgs[0];
    const playbackContext = eventArgs[3] || {};
    if (!trackData || !this.isOwnTrack(trackData.id)) {
      return;
    }

    this.setState({ activeTrackVariant: playbackContext.trackVariantId ? this.variantForId(playbackContext.trackVariantId) : null });
  }

  handlePlayTrack(args) {
    const eventArgs = Array.isArray(args) ? args : [args];
    if (this.isOwnTrack(eventArgs[0])) {
      this.setState({ activeTrackVariant: null });
    }
  }

  handlePlayTrackVariant(args) {
    const eventArgs = Array.isArray(args) ? args : [args];
    const variant = this.variantForId(eventArgs[0]);
    const trackId = eventArgs[1] || variant.track_id;
    if (this.isOwnTrack(trackId)) {
      this.setState({ activeTrackVariant: variant });
    }
  }

  trigger(eventName, payload) {
    if (!legacyEventHub || typeof legacyEventHub.trigger !== 'function') {
      return;
    }

    legacyEventHub.trigger(eventName, payload);
  }

  handleFavoriteClick(event) {
    event.preventDefault();
    this.trigger('toggleTrackFavorite', { trackId: this.props.trackId });
  }

  handleDemoDownloadClick(event) {
    event.preventDefault();

    if (!this.props.downloadAllowed) {
      return;
    }

    this.trigger('triggerTrackDemoDownload', { trackId: this.props.trackId });
  }

  handleShareClick(event) {
    event.preventDefault();
    this.trigger('triggerTrackShare', { trackId: this.props.trackId });

    if (!navigator.share) {
      this.setState({ shareCopied: true }, () => {
        window.setTimeout(() => {
          this.setState({ shareCopied: false });
        }, 2000);
      });
    }
  }

  handleLicenseClick(event) {
    event.preventDefault();
    this.trigger('openTrackUsageLicenseSelect', { trackId: this.props.trackId });
  }

  isFavorited() {
    return (this.state.trackFavorites || []).some((favorite) => String(favorite.track_id) === String(this.props.trackId));
  }

  renderAction({ key, iconClassName, label, onClick, disabled, active }) {
    const className = [
      'track-show-hero__action-item',
      active ? 'track-show-hero__action-item--active' : '',
      key === 'license' ? 'track-show-hero__action-item--primary' : '',
      disabled ? 'track-show-hero__action-item--disabled' : ''
    ].filter(Boolean).join(' ');

    return (
      <button
        key={key}
        type='button'
        className={className}
        onClick={onClick}
        disabled={disabled}
      >
        <span className='track-show-hero__action-icon'><i className={iconClassName}></i></span>
        <span className='track-show-hero__action-label'>{label}</span>
      </button>
    );
  }

  render() {
    const favorited = this.isFavorited();
    const shareLabel = this.state.shareCopied ? this.props.i18n.shareCopied : this.props.i18n.share;

    const actions = [
      {
        key: 'favorite',
        iconClassName: favorited ? 'fa fa-heart' : 'fa fa-heart-o',
        label: favorited ? this.props.i18n.remembered : this.props.i18n.remember,
        onClick: this.handleFavoriteClick,
        active: favorited
      },
      {
        key: 'download',
        iconClassName: 'fa fa-download',
        label: this.props.i18n.download,
        onClick: this.handleDemoDownloadClick,
        disabled: !this.props.downloadAllowed
      },
      {
        key: 'share',
        iconClassName: 'fa fa-link',
        label: shareLabel,
        onClick: this.handleShareClick
      }
    ];

    const licenseAction = {
      key: 'license',
      iconClassName: 'fa fa-shopping-cart',
      label: this.props.i18n.license,
      onClick: this.handleLicenseClick
    };

    const activeVariant = this.state.activeTrackVariant;
    const projectAction = this.props.projectActionEnabled ? (
      <ProjectAddTo
        key={`hero-project-action-${this.props.trackId}-${activeVariant?.id || 'track'}`}
        trackId={this.props.trackId}
        trackTitle={this.props.trackTitle}
        trackVariantId={activeVariant?.id || null}
        trackVariantTitle={activeVariant?.title}
        locale={this.props.locale}
        enabled={this.props.projectActionEnabled}
      />
    ) : null;

    return (
      <div className='track-show-hero__action-bar'>
        {actions.map((action) => this.renderAction(action))}
        {projectAction}
        {this.renderAction(licenseAction)}
      </div>
    );
  }
}

TrackHeroActionBar.defaultProps = {
  downloadAllowed: true,
  trackFavorites: [],
  projectActionEnabled: false,
  trackTitle: '',
  trackVariants: [],
  locale: 'de',
  i18n: {
    remember: 'merken',
    remembered: 'gemerkt',
    download: 'Demo',
    share: 'Link kopieren',
    shareCopied: 'Kopiert',
    license: 'Lizenz'
  }
};

let elements = document.querySelectorAll('[data-react-component=TrackHeroActionBar]');

elements.forEach(function(element) {
  try {
    let reactProps = parseReactProps(element.dataset.reactProps);

    ReactDOM.render(
      <React.StrictMode>
        <TrackHeroActionBar {...reactProps} />
      </React.StrictMode>,
      element
    );
  } catch (error) {
    console.error('Failed to mount TrackHeroActionBar', error);
  }
});

export default TrackHeroActionBar;
